module.exports = new __parcel__URL__("hand_pointing_10_oclock.a81b2bc1.png").toString();